/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
import Button from 'elements/Button';
import AboutItems from 'data/about';
import { Fade } from 'react-awesome-reveal';

/* small slugify util (keeps consistency with Header/other parts) */
function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')        // spaces/underscores -> dash
    .replace(/[^\w-]+/g, '')        // remove non-word chars except dash
    .replace(/--+/g, '-');          // collapse multiple dashes
}

export default function About() {
  return (
    <>
      {/* HERO */}
      <section className="hero py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-6 text-center">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl font-bold text-theme-blue mb-4">About FAJTech</h1>
          </Fade>
          <Fade direction="up" delay={200} triggerOnce>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We design, build and support IT systems that keep businesses secure and productive.
              Learn about our mission, awards, sustainable initiatives, and the team behind FAJTech.
            </p>
          </Fade>
        </div>
      </section>

      {/* INTRO CTA */}
      <section className="py-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="text-2xl font-semibold text-theme-blue">Want to talk with someone on our team?</h2>
              <p className="text-gray-600 mt-2">Book a consultation or send us a message and we’ll get back within one business day.</p>
            </div>
            <div className="flex gap-3">
              <Button type="link" href="/book-consultation" className="px-6 py-3 bg-theme-purple text-white rounded-full">Book Consultation</Button>
              <Button type="link" href="/contact" className="px-6 py-3 border border-theme-purple text-theme-purple rounded-full">Contact</Button>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT ITEMS grid */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-6">
          <Fade direction="up" triggerOnce>
            <h3 className="text-3xl font-extrabold text-theme-blue text-center mb-6">Explore</h3>
            <p className="text-gray-600 text-center mb-10">Learn more about who we are and what we stand for.</p>
          </Fade>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {AboutItems.map((item, idx) => {
              const slug = slugify(item);
              return (
                <Fade direction="up" triggerOnce delay={120 * idx} key={item}>
                  <div className="rounded-2xl shadow-lg p-6 bg-white border">
                    <h4 className="text-xl font-semibold text-theme-blue mb-3">{item}</h4>
                    <p className="text-gray-600 mb-6">
                      {/* Placeholder description — replace with your own copy if you want */}
                      Read our {item.toLowerCase()} to get a better sense of FAJTech values and services.
                    </p>
                    <div className="flex">
                      <Button
                        type="link"
                        href={`/about/${slug}`}
                        className="px-4 py-2 bg-theme-purple text-white rounded-full"
                      >
                        Read More
                      </Button>
                    </div>
                  </div>
                </Fade>
              );
            })}
          </div>
        </div>
      </section>

      {/* Optional: Team / CTA */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <h3 className="text-2xl font-bold text-theme-blue mb-3">Meet the team</h3>
          <p className="text-gray-600 mb-6">Our team are engineers, designers and support specialists who care about solving real problems.</p>
          <Button type="link" href="/team" className="px-6 py-3 bg-theme-purple text-white rounded-full">See Our Team</Button>
        </div>
      </section>
    </>
  );
}
